import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.244444 6.42267C-0.080993 6.09723 -0.080993 5.5696 0.244444 5.24416L5.24444 0.244159C5.56988 -0.0812783 6.09752 -0.0812783 6.42296 0.244159L11.423 5.24416C11.7484 5.5696 11.7484 6.09723 11.423 6.42267C11.0975 6.74811 10.5699 6.74811 10.2444 6.42267L5.8337 2.01193L1.42296 6.42267C1.09752 6.74811 0.569881 6.74811 0.244444 6.42267Z" fill="currentColor" />
  </svg>
)